import type { Session } from "@models/ISchema";
import type { EditedSession } from "../context/formData.reducer";
import type { Week } from "../context/linkData.reducer";

const toId = (value: unknown): string => String(value ?? "");

/** Two lists of ids hold the same ids, in any order. */
export const sameIds = (first: unknown[], second: unknown[]): boolean => {
  const sorted = (ids: unknown[]) => ids.map(toId).sort();
  const [a, b] = [sorted(first), sorted(second)];

  return a.length === b.length && a.every((id, index) => id === b[index]);
};

/** The weeks a session takes place in. */
export const checkedWeekIds = (weeks: Week[] | null | undefined): string[] =>
  (weeks ?? []).filter(week => week?.checked).map(week => week.id);

/** "17:30:00" and "17:30" are the same time. */
export const sameTime = (first: string | null | undefined, second: string | null | undefined) =>
  (first ?? "").slice(0, 5) === (second ?? "").slice(0, 5);

/*
 * An edited session keeps the link's own session object in `session`, typed as the GraphQL
 * Session although it has the editor's shape: these two are the only bridges between both types.
 */
export const persistedSessionOf = (edited: EditedSession | null | undefined) =>
  (edited?.session ?? undefined) as unknown as EditedSession | undefined;

export const asPersistedSession = (session: EditedSession): Session =>
  session as unknown as Session;
